/**
 * Theme utilities — extracted from CabinetPage to avoid
 * pulling the entire page into the main bundle.
 */

export function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem('onboardix_theme', theme)
}

export function initTheme() {
    const saved = localStorage.getItem('onboardix_theme') || 'light'
    applyTheme(saved)
}
